import { _lang, lang, getCurrentLang, isSystem } from '@umu/ukit-lang';

const getUnitPrice = () => {
    let unitPriceDes = lang('按年付费');
    const localeLang = getCurrentLang();
    const unitPrice = isSystem('CN') ? lang('按席位数付费，已包含10个席位') : lang('每月起，即可创建私有的学习平台2');
    if ((isSystem('EN') || isSystem('EM')) && localeLang === 'cn') {
        unitPriceDes = lang('每年');
    }
    return [unitPrice, unitPriceDes];
};
export { getUnitPrice };
